import List from '@mui/material/List';

function SidebarGroup(props) {
  return <List {...props} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
